import enUS from "./en_US.json";
import enGB from "./en_GB.json";
import { createLocaleRegistry } from "@repo/utils";

/**
 * Resolves the correct locale bundle for a given country + language code.
 * Bundles are sourced from the JSON files in this directory.
 * The registry/fallback logic is provided centrally by @repo/utils.
 *
 * To add a new locale:
 *   1. Add the JSON file here as `{lang}_{COUNTRY}.json`  (e.g. `de_CH.json`)
 *   2. Import it above                                     (e.g. `deCH`)
 *   3. Register it in the call below                       (e.g. `"de-CH": deCH`)
 */
export const getAppLocale = createLocaleRegistry({
  "en-US": enUS,
  "en-GB": enGB,
});
